import styles from '../css/components/footer.module.css'; 

export function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <p className={styles.text}>© 2026 SmartBuilders (Pty) Ltd. All rights reserved.</p>
      </div>
    </footer>
  )
}

export default Footer;